import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Routes, Route, useNavigate, useParams } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
  Table,
  Alert,
  Button,
  Form,
  Card,
  Modal
} from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { generateReceipt, salesList } from '../actions/posActions'
import { updateInventorymulti } from '../actions/inventoryActions'
import SearchPos from '../components/PosSearchBox'
import PaginatePos from '../components/PaginatePos'
import Message from '../components/Message'
import Loader from '../components/Loader'
import AddShipping from '../components/AddShipping'
import { GET_SALE_ITEM_RESET } from '../constants/saleConstants'

// Import actions
// import { outSide } from '../actions/posActions.js'

// Import icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'

// Initialize variables
let subtotal = []
let discountarray = []
let salearray = []
let totaldisc = 0
let applieddisc = 0
let itemdisc = 0
let itemnodisc = 0
let itemwithdisc = 0
let cid = ''
let bname = ''
let apikey = ''

// Change quantity, discount from useState
let quantity = 0
let discount = 0
let updatearray = []
// let cid = ''
// let bname = ''

const Pointofsale = () => {
  // Initialize state variables
  const [currentsub, setCurrentsub] = useState(0)
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const [shipping, setShipping] = useState(0)
  const [qrid, setQrid] = useState('')

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { pageNumberpos } = useParams() || 1
  const { keyword } = useParams()

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  // Generate file name for use through out application
  if (userInfo) {
    cid = userInfo.cid
    bname = userInfo.bname
    apikey = userInfo.apikey
  }

  const vfname = bname.toLowerCase().replace(/\s/g, '')

  const rstoredate = new Date()
  const date = ('0' + rstoredate.getDate()).slice(-2)
  const month = ('0' + (rstoredate.getMonth() + 1)).slice(-2)
  const year = rstoredate.getFullYear()
  const hours = rstoredate.getHours()
  const minutes = rstoredate.getMinutes()
  const qfname = `${date}${month}${year}${hours}${minutes}-${vfname}.png`

  const saleList = useSelector((state) => state.saleList)
  const { sales, loading, error, pagespos, pagepos, countpos } = saleList

  const settingList = useSelector((state) => state.settingList)
  const { settings } = settingList

  const { taxrate } = settings
  const totalwithtax = 1 + taxrate / 100

  // Function to pass shipping cost from child to parent
  function childToparent(data) {
    setShipping(Number(data))
    return
  }

  // Function to delete item from purchase list
  const deleteItem = (id) => {
    const deletesaleitem = salearray.findIndex((item) => item.id === id)
    salearray.splice(deletesaleitem, 1)
    subtotal.splice(deletesaleitem, 1)
    setCurrentsub(subtotal.reduce((a, b) => a + b, 0))
    return
  }

  // Receipt function
  const Receipt = (unit, qty, discount) => {
    // Test for discount to apply to item
    if (discount !== undefined) {
      applieddisc = 1 - Number(discount) / 100
    }

    // Create object for each item in receipt
    const saleitem = {
      id: unit._id,
      upc: unit.upc,
      cid: unit.cid,
      item: unit.item,
      manufacturer: unit.manufacturer,
      subname: unit.subname,
      price: unit.price,
      allqty: unit.qty,
      quantity: qty,
      itemdiscount: discount,
      discprice: unit.price * applieddisc
    }

    if (saleitem) {
      discount = 0
    }

    // Calculate discount for each item
    itemnodisc = Number(saleitem.price * saleitem.quantity).toFixed(2)
    itemwithdisc = Number(
      saleitem.price * saleitem.quantity * applieddisc
    ).toFixed(2)
    itemdisc = (itemnodisc - itemwithdisc).toFixed(2)

    if (itemdisc !== 'NaN') {
      discountarray.push(Number(itemdisc))
    }

    // Create array of discounts to apply to subtotal
    totaldisc = discountarray.reduce((a, b) => a + b, 0)

    // Calculate subtotal
    if (applieddisc !== 1) {
      subtotal.push(Number(itemwithdisc))
      setCurrentsub(subtotal.reduce((a, b) => a + b, 0))
      quantity = 1
      discount = 0
    } else {
      subtotal.push(Number(itemnodisc))
      setCurrentsub(subtotal.reduce((a, b) => a + b, 0))
    }

    // Create array of items to display in receipt
    if (unit.item) {
      const id = unit._id
      const price = unit.price

      const double = salearray.find((item) => item.id === id)

      if (double === undefined) {
        salearray.push(saleitem)
      } else {
        window.alert('Item already in receipt')
        const dupsubtotal = subtotal.indexOf(price)

        subtotal.splice(dupsubtotal, 1)
        setCurrentsub(subtotal.reduce((a, b) => a + b, 0))

        quantity = 1
        return
      }
    }

    // Create array of items to update sales
    if (salearray.length >= 0) {
      salearray.forEach((saleitem) => {
        const unit = {
          _id: saleitem.id,
          qty: saleitem.allqty - saleitem.quantity,
          cid: saleitem.cid,
          upc: saleitem.upc,
          saleqty: saleitem.quantity,
          item: saleitem.item,
          manufacturer: saleitem.manufacturer,
          subname: saleitem.subname,
          price: saleitem.price.toFixed(2),
          itemdiscount: saleitem.itemdiscount
        }
        updatearray = [...updatearray, unit]
        return updatearray
      })
    }
  }

  // Assemble monies for receipt fields
  const allmoney = {
    total: ((currentsub + shipping) * totalwithtax).toFixed(2),
    subtotal: currentsub.toFixed(2),
    discount: totaldisc.toFixed(2),
    shipping: shipping.toFixed(2),
    taxes: (((currentsub + shipping) * taxrate) / 100).toFixed(2)
  }

  // Generate the barcode vaule for the receipt
  function generateRandomNumber() {
    const min = 100000000000 // Minimum twelve-digit number
    const max = 999999999999 // Maximum twelve-digit number

    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  const randomTwelveDigitNumber = generateRandomNumber()
  const barcode = randomTwelveDigitNumber.toString()

  const outSidedata = {
    qrid,
    qfname,
    cid,
    barcode,
    apikey
  }

  // Cancel receipt
  const cancelRcpt = () => {
    if (salearray.length !== 0) {
      salearray = []
      subtotal = []
      setCurrentsub(0)
      updatearray = []
      discountarray = []
      itemdisc = 0
      itemnodisc = 0
      itemwithdisc = 0
      totaldisc = 0
      applieddisc = 0
      setShipping(0)
      navigate('/pos')
      return
    }
  }
  // Checkout receipt
  let uniqueObjects = [
    ...new Map(updatearray.map((item) => [item._id, item])).values()
  ]

  const objcount = uniqueObjects.length

  uniqueObjects.unshift(allmoney)

  const inventoryupdate = uniqueObjects.slice(1)

  // Checkout and generate receipt
  const checkOut = (e) => {
    e.preventDefault()

    if (qrid === '') {
      dispatch(updateInventorymulti(inventoryupdate, objcount))
    } else {
      dispatch(updateInventorymulti(inventoryupdate, objcount))
      dispatch(generateReceipt(uniqueObjects, outSidedata))
      // outSide(outSidedata)
    }

    handleClose()
    salearray = []
    subtotal = []
    setCurrentsub(0)
    updatearray = []
    setQrid('')
    discountarray = []
    itemdisc = 0
    itemnodisc = 0
    itemwithdisc = 0
    totaldisc = 0
    applieddisc = 0
    setShipping(0)
    navigate('/pos')
    uniqueObjects = []
    return
  }

  useEffect(() => {
    dispatch(salesList(pageNumberpos, keyword))
    quantity = 1
    discount = 0
  }, [dispatch, navigate, pageNumberpos, keyword, userInfo])

  useEffect(() => {
    if (!userInfo) {
      dispatch({ type: GET_SALE_ITEM_RESET })
      navigate('/login')
    }
  }, [dispatch, navigate, userInfo])

  useEffect(() => {
    if (userInfo === undefined) {
      localStorage.getItem('userInfo')
    }
  }, [userInfo])

  return (
    <Container>
      <Row className='align-items-center my-2'>
        <Col>
          <h3 className='my-2'>Point of Sale Terminal</h3>
        </Col>
      </Row>
      <Row className='align-items-center my-2'>
        <Col>
          <Routes>
            <Route path='/*' element={<SearchPos />} />
          </Routes>
        </Col>
      </Row>

      <PaginatePos pagespos={pagespos} pagepos={pagepos} />
      {alert.show && <Alert variant={alert.variant}>{alert.message}</Alert>}
      {countpos === 0 && <Message variant='info'>None Found</Message>}
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <Row>
          <Col>
            <Table
              striped
              bordered
              hover
              responsive
              className='table-sm my-2'
              variant='active'
            >
              <thead>
                <tr>
                  <th>Mfg</th>
                  <th>Name</th>
                  <th>Qty</th>
                  <th>Price</th>
                  <th width='80px'>Select</th>
                  <th width='70px'>Disc</th>
                </tr>
              </thead>
              <tbody>
                {sales.map(
                  (unit) =>
                    unit.qty > 0 && (
                      <tr key={unit._id}>
                        <td>{unit.manufacturer}</td>
                        <td>{unit.subname}</td>

                        <td>{unit.qty}</td>
                        <td align='right'>
                          {unit.price.toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD'
                          })}
                        </td>
                        <td>
                          <Form>
                            <Form.Group controlId='quantity'>
                              <Form.Control
                                type='number'
                                min='1'
                                max={unit.qty}
                                defaultValue={quantity}
                                onChange={(e) => (quantity = e.target.value)}
                              ></Form.Control>
                            </Form.Group>
                            <LinkContainer to={`/pos/${unit._id}`}>
                              <Button
                                variant='primary'
                                size='sm'
                                onClick={() =>
                                  Receipt(unit, quantity, discount)
                                }
                              >
                                <FontAwesomeIcon icon={faEdit} />
                              </Button>
                            </LinkContainer>
                          </Form>
                        </td>
                        <td>
                          <Form.Group controlId='discount'>
                            <Form.Control
                              type='number'
                              min='0'
                              max='50'
                              defaultValue={discount}
                              onChange={(e) => (discount = e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </td>
                      </tr>
                    )
                )}
              </tbody>
            </Table>
          </Col>
          <Col>
            <Card>
              <Card.Header>
                <h4>Receipt</h4>
              </Card.Header>
              <Card.Body>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Mfg</th>
                      <th>Name</th>
                      <th>Qty</th>
                      <th>Per</th>
                      <th>Disc</th>
                      <th>Price</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {salearray.length !== 0 &&
                      salearray.map((saleitem) => (
                        <tr key={saleitem.id}>
                          <td>{saleitem.manufacturer}</td>
                          <td>{saleitem.subname}</td>
                          <td align='center'>{saleitem.quantity}</td>
                          <td align='right'>
                            {saleitem.price.toLocaleString('en-US', {
                              style: 'currency',
                              currency: 'USD'
                            })}
                          </td>

                          <td align='right'>{saleitem.itemdiscount}%</td>
                          <td align='right'>
                            {saleitem.discprice !== 0
                              ? (
                                  saleitem.discprice * saleitem.quantity
                                ).toLocaleString('en-US', {
                                  style: 'currency',
                                  currency: 'USD'
                                })
                              : (
                                  saleitem.price * saleitem.quantity
                                ).toLocaleString('en-US', {
                                  style: 'currency',
                                  currency: 'USD'
                                })}
                          </td>
                          <td>
                            <Button
                              variant='danger'
                              size='sm'
                              onClick={(e) => deleteItem(saleitem.id)}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </Button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </Card.Body>
              <Card.Footer>
                <Row>
                  <Col>Subtotal</Col>
                  <Col align='right'>
                    {currentsub.toLocaleString('en-US', {
                      style: 'currency',
                      currency: 'USD'
                    })}
                  </Col>
                </Row>
                <Row>
                  <Col>Disc on sale</Col>
                  <Col align='right'>
                    {'-'}{' '}
                    {totaldisc.toLocaleString('en-US', {
                      style: 'currency',
                      currency: 'USD'
                    })}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <AddShipping childToparent={childToparent} />
                    <hr className='solid' />
                  </Col>
                  <Col align='right'>
                    {shipping.toLocaleString('en-US', {
                      style: 'currency',
                      currency: 'USD'
                    })}
                  </Col>
                </Row>
                <Row>
                  <Col>Tax</Col>
                  <Col align='right'>
                    {(((currentsub + shipping) * taxrate) / 100).toLocaleString(
                      'en-US',
                      {
                        style: 'currency',
                        currency: 'USD'
                      }
                    )}{' '}
                    @ {settings.taxrate}%{' '}
                  </Col>
                </Row>
                <Row>
                  <Col>Total</Col>
                  <Col align='right'>
                    {((currentsub + shipping) * totalwithtax).toLocaleString(
                      'en-US',
                      {
                        style: 'currency',
                        currency: 'USD'
                      }
                    )}
                    <br />
                  </Col>
                </Row>
                <Col>
                  {objcount > 0 && (
                    <Button
                      className='btn btn-outline btn-sm text-left'
                      size='sm'
                      onClick={handleShow}
                    >
                      Checkout
                    </Button>
                  )}
                  <Modal show={show}>
                    <Modal.Header closeButton>
                      <Modal.Title>Finish Sale</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Col>
                        Total:{' '}
                        {(
                          (currentsub + shipping) *
                          totalwithtax
                        ).toLocaleString('en-US', {
                          style: 'currency',
                          currency: 'USD'
                        })}
                      </Col>

                      <Form.Group controlId='qrid'>
                        <Form.Control
                          type='string'
                          align='left'
                          width='80%'
                          placeholder='Scan QRcode option'
                          value={qrid}
                          onChange={(e) => setQrid(e.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant='danger' onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button variant='primary' onClick={checkOut}>
                        Save
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </Col>
                <Col align='right'>
                  <Button
                    variant='danger'
                    size='sm'
                    align='right'
                    onClick={() => cancelRcpt()}
                  >
                    Cancel Sale
                  </Button>
                </Col>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      )}
    </Container>
  )
}

export default Pointofsale
